<template>
    <div>
        <google-map :address="address" :zoom="zoom" />
    </div>
</template>

<script>
import GoogleMap from '@/components/GoogleMap';
export default {
    data() {
        return {
           
        }
    },
    components: {
        GoogleMap
    },
    props: {
        address: {
            type: String
        },
        zoom: {
            type: Number
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/components/aha-google-map.vue